/* eslint-disable max-len */
/**
 * English translations.
 */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Accept and Activate',
    APPROVE: 'Approve',
    CANCEL: 'Cancel',
    SAVE: 'Save'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX: 'I have read and accept the Terms and Conditions',
    ACCEPT_TERMS_DESCRIPTION:
      'Before accessing the Prozis Partnership platform, please review and accept the Prozis Influencer Program Terms and Conditions.',
    ACCEPT_TERMS_NAV_TITLE: 'Terms and Conditions',
    ACCEPT_TERMS_SCROLL_HINT: 'Please read to the end to continue.',
    DASHBOARD: 'Dashboard',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'We noticed that you do not have notifications active, to be able to continue using the app we need you to activate notifications.',
    ENABLE_NOTIFICATIONS_LINK: 'You can turn on notifications here',
    ENABLE_NOTIFICATIONS_NAV_TITLE: 'Notifications',
    ENABLE_NOTIFICATIONS_TITLE: 'Activate notifications so you can continue',
    HOME: 'Home',
    INSTALL_PROZIS_APP: 'Install Prozis Store App',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Install our mobile app to continue accessing all the features.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'Install App',
    LOGOUT: 'Logout',
    NOT_FOUND: 'Not found',
    OR: 'Or',
    OR_SCAN_QR_CODE: 'Or scan the QR code',
    SCAN_QR_CODE: 'Scan the QR code with your mobile device',
    TODOS: 'All',
    UNAUTHORIZED_DESCRIPTION_1:
      'Check with your manager for access permissions.',
    UNAUTHORIZED_DESCRIPTION_2: 'After verification, try logging in again.',
    UNAUTHORIZED_NAV_TITLE: 'Access Denied',
    UNAUTHORIZED_TITLE: 'No access permission'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
